import React, { memo, useEffect, useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import './resend.scss';

interface ResendCodeProps {
  sendOtp: () => void;
}

const ResendCode: React.FC<ResendCodeProps> = (props) => {
  const { sendOtp } = props;
  const [counter, setCounter] = useState(120);
  const [active, setActive] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      if (active) {
        setCounter((prev) => prev - 1);
      }
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [active]);

  useEffect(() => {
    if (counter === 0) {
      setActive(false);
    }
  }, [counter]);

  const onClickResendCode = async () => {
    sendOtp();
    setActive(true);
    setCounter(120);
  };

  return (
    <Box className='resend'>
      {counter === 0 ? (
        <IconButton disableRipple onClick={onClickResendCode} sx={{ padding: 0 }}>
          <Typography color='text.main' className='message'>
            ارسال مجدد
          </Typography>
        </IconButton>
      ) : (
        <Typography color='text.main' className='message'>
          {`${counter > 60 ? '01' : '00'}:${
            counter > 60 ? counter - 60 : counter === 0 ? '00' : counter
          } مانده تا دریافت مجدد کد`}
        </Typography>
      )}
    </Box>
  );
};

export default memo(ResendCode);
